import { Modal } from '@app/components/various/Modal';
import { copyToNewSelectionRequest, getIsSeller } from '@app/ducks';
import { isDefined } from '@app/utils/is';
import { Id } from '@typings';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';

import { OrderSettingsForm } from '../OrderSettingsForm';

interface Props {
  orderId?: Id;
  orderNumber?: string;
  defaultBuyer?: string;
  onSubmit?: () => void;
  isOpen: boolean;
  onClose: VoidFunction;
}

export const CopyToNewSelectionModal = ({ orderId, defaultBuyer, orderNumber, onSubmit, isOpen, onClose }: Props) => {
  const dispatch = useDispatch();
  const isSeller = useSelector(getIsSeller);
  const { t } = useTranslation(['common', 'selections']);

  const handleSubmit = ({ name, buyer }: { name: string; buyer?: string }) => {
    if (!isDefined(orderId) || !isDefined(orderNumber)) {
      return;
    }

    const payload = {
      name,
      orderId,
      orderNumber,
      ...(isSeller ? { buyer } : {}),
    };
    dispatch(copyToNewSelectionRequest(payload));
    onSubmit?.();
  };

  return (
    <Modal
      title={t('selections:copy_to_new_selection')}
      description={isSeller && t('selections:copy_to_new_selection_description')}
      isOpen={isOpen}
      onClose={onClose}
      size="medium"
    >
      <OrderSettingsForm submitTitle={t('common:copy')} initialData={{ buyer: defaultBuyer }} onClose={onClose} onSubmit={handleSubmit} />
    </Modal>
  );
};
